export default function getHeadlineTmnt(exchangeHeadlineTmnt, isReturn, isExchange) {
  if (exchangeHeadlineTmnt) {
    return exchangeHeadlineTmnt;
  }
  if (isReturn && isExchange) {
    return 'DRE_RETURN_AND_EXCHANGE_INITIATED';
  }
  if (isExchange) {
    return 'DRE_EXCHANGE_INITIATED';
  }
  return 'DRE_RETURN_INITIATED';
}
